// action - customization reducer
export const SET_MENU = "@customization/SET_MENU";
export const MENU_TOGGLE = "@customization/MENU_TOGGLE";
export const MENU_OPEN = "@customization/MENU_OPEN";
export const SET_FONT_FAMILY = "@customization/SET_FONT_FAMILY";
export const SET_BORDER_RADIUS = "@customization/SET_BORDER_RADIUS";

// company related actions
export const GET_COMPANY_REVENUE_SUMMARY = "@company/GET_REVENUE_SUMMARY";
export const SET_COMPANY_REVENUE_SUMMARY = "@company/SET_REVENUE_SUMMARY";

// financial forecast
export const SET_COLOR = "@financialForecast/SET_COLOR";
export const RESET_COLORS = "@financialForecast/RESET_COLORS";
export const UPDATE_PRIMARY_PERIODICITY_KEY =
  "@financialForecast/UPDATE_PRIMARY_PERIODICITY_KEY";

// collapsible menus
export const SET_OPEN = "@financialForecast/SET_OPEN";
export const SET_OPEN_FLAG = "@financialForecast/SET_OPEN_FLAG";

// general assumptions
export const SET_GENERAL_ASSUMPTION =
  "@financialForecast/SET_GENERAL_ASSUMPTION";

// time series assumptions
export const SET_TIME_SERIES_ASSUMPTION =
  "@financialForecast/SET_TIME_SERIES_ASSUMPTION";

// company name
export const SET_COMPANY_NAME = "@financialForecast/SET_COMPANY_NAME";

// subscriber acquisition assumptions
// TODO: Is this valid?
export const SET_SUBSCRIBER_ACQUISITION_ASSUMPTION_BY_YEAR =
  "@subscriberAcquisitionAssumptions/SET_SUBSCRIBER_ACQUISITION_ASSUMPTION_BY_YEAR";
export const SET_SUBSCRIBER_ACQUISITION_ASSUMPTION_BY_MONTH =
  "@subscriberAcquisitionAssumptions/SET_SUBSCRIBER_ACQUISITION_ASSUMPTION_BY_MONTH";

export const RESET_SUBSCRIBER_ACQUISITION_ASSUMPTION_REDUCER =
  "@subscriberAcquisitionAssumptions/RESET_SUBSCRIBER_ACQUISITION_ASSUMPTION_REDUCER";

// net working capital assumptions
// TODO: Is this valid?
export const SET_NET_WORKING_CAPITAL_ASSUMPTION_BY_YEAR =
  "@netWorkingCapitalAssumptions/SET_NET_WORKING_CAPITAL_ASSUMPTION_BY_YEAR";

export const SET_NET_WORKING_CAPITAL_ASSUMPTION_BY_MONTHS =
  "@netWorkingCapitalAssumptions/SET_NET_WORKING_CAPITAL_ASSUMPTION_BY_MONTHS";

export const RESET_NET_WORKING_CAPITAL_ASSUMPTION_REDUCER =
  "@netWorkingCapitalAssumptions/RESET_NET_WORKING_CAPITAL_ASSUMPTION_REDUCER";

// net working capital assumptions
// TODO: Is this valid?
export const SET_CAPEX_ASSUMPTION_BY_YEAR =
  "@capexAssumptions/SET_CAPEX_ASSUMPTION_BY_YEAR";

export const SET_CAPEX_ASSUMPTION_BY_MONTH =
  "@capexAssumptions/SET_CAPEX_ASSUMPTION_BY_MONTH";

export const RESET_CAPEX_REDUCER = "@capexAssumptions/RESET_CAPEX_REDUCER";

// new installs
// TODO: Is this valid?
export const SET_NEW_INSTALL_BY_YEAR = "@newInstalls/SET_NEW_INSTALL_BY_YEAR";
export const SET_NEW_INSTALL_BY_MONTH = "@newInstalls/SET_NEW_INSTALL_BY_MONTH";

export const REPLACE_NEW_INSTALL_YEARS =
  "@newInstalls/REPLACE_NEW_INSTALL_YEARS";
export const RESET_NEW_INSTALL_REDUCER =
  "@newInstalls/RESET_NEW_INSTALL_REDUCER";

// cumulative installs
export const SET_CUMULATIVE_INSTALL_BY_YEAR =
  "@cumulativeInstalls/SET_CUMULATIVE_INSTALL_BY_YEAR";

export const SET_CUMULATIVE_INSTALL_BY_MONTH =
  "@cumulativeInstalls/SET_CUMULATIVE_INSTALL_BY_MONTH";

export const REPLACE_CUMULATIVE_INSTALL_YEARS =
  "@cumulativeInstalls/REPLACE_CUMULATIVE_INSTALL_YEARS";

export const RESET_CUMULATIVE_INSTAL_REDUCER =
  "@cumulativeInstalls/RESET_CUMULATIVE_INSTAL_REDUCER";

// cumulative members
export const SET_CUMULATIVE_MEMBER_BY_YEAR =
  "@cumulativeMembers/SET_CUMULATIVE_MEMBER_BY_YEAR";

export const SET_CUMULATIVE_MEMBER_BY_MONTHS =
  "@cumulativeMembers/SET_CUMULATIVE_MEMBER_BY_MONTHS";

export const REPLACE_CUMULATIVE_MEMBER_YEARS =
  "@cumulativeMembers/REPLACE_CUMULATIVE_MEMBER_YEARS";

export const RESET_CUMULATIVE_MEMBER_REDUCER =
  "@cumulativeMembers/RESET_CUMULATIVE_MEMBER_REDUCER";

// cumulative subscribers
export const SET_CUMULATIVE_SUBSCRIBER_BY_YEAR =
  "@cumulativeSubscribers/SET_CUMULATIVE_SUBSCRIBER_BY_YEAR";

export const SET_CUMULATIVE_SUBSCRIBER_BY_MONTH =
  "@cumulativeSubscribers/SET_CUMULATIVE_SUBSCRIBER_BY_MONTH";

export const REPLACE_CUMULATIVE_SUBSCRIBER_YEARS =
  "@cumulativeSubscribers/REPLACE_CUMULATIVE_SUBSCRIBER_YEARS";

export const RESET_CUMULATIVE_SUBSCRIBER_REDUCER =
  "@cumulativeSubscribers/RESET_CUMULATIVE_SUBSCRIBER_REDUCER";

// subscription revenue
export const SET_SUBSCRIPTION_REVENUE_BY_YEAR =
  "@subscriptionRevenue/SET_SUBSCRIPTION_REVENUE_BY_YEAR";

export const SET_SUBSCRIPTION_REVENUE_BY_MONTH =
  "@subscriptionRevenue/SET_SUBSCRIPTION_REVENUE_BY_MONTH";

export const REPLACE_SUBSCRIPTION_REVENUE_YEARS =
  "@subscriptionRevenue/REPLACE_SUBSCRIPTION_REVENUE_YEARS";

export const RESET_SUBSCRIPTION_REVENUE_REDUCER =
  "@subscriptionRevenue/RESET_SUBSCRIPTION_REVENUE_REDUCER";

// subscription commissions
export const SET_SUBSCRIPTION_COMMISSION_BY_YEAR =
  "@subscriptionCommissions/SET_SUBSCRIPTION_COMMISSION_BY_YEAR";

export const SET_SUBSCRIPTION_COMMISSION_BY_MONTH =
  "@subscriptionCommissions/SET_SUBSCRIPTION_COMMISSION_BY_MONTH";

export const REPLACE_SUBSCRIPTION_COMMISSION_YEARS =
  "@subscriptionCommissions/REPLACE_SUBSCRIPTION_COMMISSION_YEARS";

export const RESET_SUBSCRIPTION_COMMISSION_REDUCER =
  "@subscriptionCommissions/RESET_SUBSCRIPTION_COMMISSION_REDUCER";

// subscription revenue
export const SET_OTHER_REVENUE_BY_YEAR =
  "@subscriptionCommissions/SET_OTHER_REVENUE_BY_YEAR";
export const SET_OTHER_REVENUE_BY_MONTH =
  "@subscriptionCommissions/SET_OTHER_REVENUE_BY_MONTH";

export const REPLACE_OTHER_REVENUE_YEARS =
  "@subscriptionCommissions/REPLACE_OTHER_REVENUE_YEARS";

export const RESET_OTHER_REVENUE_REDUCER =
  "@subscriptionCommissions/RESET_OTHER_REVENUE_REDUCER";

// cost of sales
export const SET_COST_OF_SALE_BY_YEAR =
  "@costAndExpenses/SET_COST_OF_SALE_BY_YEAR";

export const SET_COST_OF_SALE_BY_MONTH =
  "@costAndExpenses/SET_COST_OF_SALE_BY_MONTH";

export const REPLACE_COST_OF_SALES_YEAR =
  "@costAndExpenses/REPLACE_COST_OF_SALES_YEAR";

export const RESET_COST_OF_SALES_REDUCER =
  "@costAndExpenses/RESET_COST_OF_SALES_REDUCER";

// cost of sales
export const SET_COST_OF_SALE_CONTD_BY_YEAR =
  "@costAndExpenses/SET_COST_OF_SALE_CONTD_BY_YEAR";
export const SET_COST_OF_SALE_CONTD_BY_MONTH =
  "@costAndExpenses/SET_COST_OF_SALE_CONTD_BY_MONTH";

export const REPLACE_COST_OF_SALE_CONTD_YEARS =
  "@costAndExpenses/REPLACE_COST_OF_SALE_CONTD_YEARS";

export const REPLACE_COST_OF_SALE_CONTD_MONTHS =
  "@costAndExpenses/REPLACE_COST_OF_SALE_CONTD_MONTHS";

export const RESET_COST_OF_SALE_CONTD_REDUCER =
  "@costAndExpenses/RESET_COST_OF_SALE_CONTD_REDUCER";

export const SET_COST_OF_SALE_CONTD_INITIAL_PERIOD =
  "@costAndExpenses/SET_COST_OF_SALE_CONTD_INITIAL_PERIOD";

export const SET_COST_OF_SALE_CONTD_INITIAL_PERIOD_MONTH =
  "@costAndExpenses/SET_COST_OF_SALE_CONTD_INITIAL_PERIOD_MONTH";

// general administrative expenses
export const SET_GENERAL_ADMINISTRATIVE_EXPENSE_BY_YEAR =
  "@generalAdministrativeExpenses/SET_GENERAL_ADMINISTRATIVE_EXPENSE_BY_YEAR";

export const SET_GENERAL_ADMINISTRATIVE_EXPENSE_BY_MONTHS =
  "@generalAdministrativeExpenses/SET_GENERAL_ADMINISTRATIVE_EXPENSE_BY_MONTHS";

export const REPLACE_GENERAL_ADMINISTRATIVE_EXPENSE_BY_YEAR =
  "@generalAdministrativeExpenses/REPLACE_GENERAL_ADMINISTRATIVE_EXPENSE_BY_YEAR";

export const RESET_GENERAL_ADMINISTRATIVE_EXPENSE_REDUCER =
  "@generalAdministrativeExpenses/RESET_GENERAL_ADMINISTRATIVE_EXPENSE_REDUCER";

export const SET_SALES_AND_MARKETING_EXPENSE_BY_YEAR =
  "@salesAndMarketingExpenses/SET_SALES_AND_MARKETING_EXPENSE_BY_YEAR";

export const SET_SALES_AND_MARKETING_EXPENSE_BY_MONTH =
  "@salesAndMarketingExpenses/SET_SALES_AND_MARKETING_EXPENSE_BY_MONTH";

export const REPLACE_SALES_AND_MARKETING_EXPENSE_YEARS =
  "@salesAndMarketingExpenses/REPLACE_SALES_AND_MARKETING_EXPENSE_YEARS";

export const RESET_SALES_AND_MARKETING_EXPENSE_REDUCER =
  "@salesAndMarketingExpenses/RESET_SALES_AND_MARKETING_EXPENSE_REDUCER";

export const SET_ADVERTISEMENT_EXPENSE_BY_YEAR =
  "@advertisementExpenses/SET_ADVERTISEMENT_EXPENSE_BY_YEAR";

export const SET_ADVERTISEMENT_EXPENSE_BY_MONTHS =
  "@advertisementExpenses/SET_ADVERTISEMENT_EXPENSE_BY_MONTHS";

export const REPLACE_ADVERTISEMENT_EXPENSE_YEARS =
  "@advertisementExpenses/REPLACE_ADVERTISEMENT_EXPENSE_BY_YEARS";

export const RESET_ADVERTISEMENT_EXPENSE_REDUCER =
  "@advertisementExpenses/RESET_ADVERTISEMENT_EXPENSE_REDUCER";

export const SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_YEAR =
  "@otherAdvExpenses/SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_YEAR";

export const SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_MONTH =
  "@otherAdvExpenses/SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_MONTH";

export const REPLACE_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_YEARS =
  "@otherAdvExpenses/REPLACE_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_YEARS";

export const RESET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_REDUCER =
  "@otherAdvExpenses/RESET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_REDUCER";

// HIRING PLAN START //
export const SET_FOUNDERS_AND_PARTNERS_BY_YEAR =
  "@hiringPlan/SET_FOUNDERS_AND_PARTNERS_BY_YEAR";

export const SET_FOUNDERS_AND_PARTNERS_BY_MONTH =
  "@hiringPlan/SET_FOUNDERS_AND_PARTNERS_BY_MONTH";

export const REPLACE_FOUNDERS_AND_PARTNERS_YEARS =
  "@hiringPlan/SET_FOUNDERS_AND_PARTNERS_BY_YEARS";

export const RESET_FOUNDERS_AND_PARTNERS_REDUCER =
  "@hiringPlan/RESET_FOUNDERS_AND_PARTNERS_REDUCER";

export const SET_TECH_PRODUCT_DEV_BY_YEAR =
  "@hiringPlan/SET_TECH_PRODUCT_DEV_BY_YEAR";

export const SET_TECH_PRODUCT_DEV_BY_MONTH =
  "@hiringPlan/SET_TECH_PRODUCT_DEV_BY_MONTH";

export const REPLACE_TECH_PRODUCT_DEV_YEARS =
  "@hiringPlan/REPLACE_TECH_PRODUCT_DEV_YEARS";

export const RESET_TECH_PRODUCT_DEV_REDUCER =
  "@hiringPlan/RESET_TECH_PRODUCT_DEV_REDUCER";

export const SET_SALES_MARKETING_BY_YEAR =
  "@hiringPlan/SET_SALES_MARKETING_BY_YEAR";

export const SET_SALES_MARKETING_BY_MONTH =
  "@hiringPlan/SET_SALES_MARKETING_BY_MONTH";

export const REPLACE_SALES_MARKETING_BY_YEAR =
  "@hiringPlan/REPLACE_SALES_MARKETING_BY_YEAR";

export const RESET_SALES_MARKETING_REDUCER =
  "@hiringPlan/RESET_SALES_MARKETING_REDUCER";

export const SET_FINANCE_ANALYTICS_BY_YEAR =
  "@hiringPlan/SET_FINANCE_ANALYTICS_BY_YEAR";

export const SET_FINANCE_ANALYTICS_BY_MONTHS =
  "@hiringPlan/SET_FINANCE_ANALYTICS_BY_MONTHS";

export const REPLACE_FINANCE_ANALYTICS_YEARS =
  "@hiringPlan/REPLACE_FINANCE_ANALYTICS_YEARS";

export const RESET_FINANCE_ANALYTICS_REDUCER =
  "@hiringPlan/RESET_FINANCE_ANALYTICS_REDUCER";

export const SET_HIRING_PLAN_OTHER_BY_YEAR =
  "@hiringPlan/SET_HIRING_PLAN_OTHER_BY_YEAR";

export const SET_HIRING_PLAN_OTHER_BY_MONTH =
  "@hiringPlan/SET_HIRING_PLAN_OTHER_BY_MONTH";

export const REPLACE_HIRING_PLAN_OTHER_YEARS =
  "@hiringPlan/REPLACE_HIRING_PLAN_OTHER_YEARS";

export const RESET_HIRING_PLAN_OTHER_REDUCER =
  "@hiringPlan/RESET_HIRING_PLAN_OTHER_REDUCER";

export const SET_HIRING_PLAN_AVERAGE_BY_YEAR =
  "@hiringPlan/SET_HIRING_PLAN_AVERAGE_BY_YEAR";

export const SET_HIRING_PLAN_AVERAGE_BY_MONTHS =
  "@hiringPlan/SET_HIRING_PLAN_AVERAGE_BY_MONTHS";

export const REPLACE_HIRING_PLAN_AVERAGE_YEARS =
  "@hiringPlan/REPLACE_HIRING_PLAN_AVERAGE_YEARS";

export const RESET_HIRING_PLAN_AVERAGE_REDUCER =
  "@hiringPlan/RESET_HIRING_PLAN_AVERAGE_REDUCER";

// HIRING PLAN END //

// PROFIT AND LOSS BEGIN //
export const SET_PROFIT_AND_LOSS_MAIN_BY_YEAR =
  "@profitAndLoss/SET_PROFIT_AND_LOSS_MAIN_BY_YEAR";

export const SET_PROFIT_AND_LOSS_MAIN_BY_MONTHS =
  "@profitAndLoss/SET_PROFIT_AND_LOSS_MAIN_BY_MONTHS";

export const REPLACE_PROFIT_AND_LOSS_MAIN_YEARS =
  "@profitAndLoss/REPLACE_PROFIT_AND_LOSS_MAIN_YEARS";

export const RESET_PROFIT_AND_LOSS_MAIN_REDUCER =
  "@profitAndLoss/RESET_PROFIT_AND_LOSS_MAIN_REDUCER";

// PROFIT AND LOSS END //

// FREE CASH FLOW BEGIN //
export const SET_FREE_CASH_FLOW_BY_YEAR =
  "@freeCashFlow/SET_FREE_CASH_FLOW_BY_YEAR";

export const SET_FREE_CASH_FLOW_BY_MONTH =
  "@freeCashFlow/SET_FREE_CASH_FLOW_BY_MONTH";

export const REPLACE_FREE_CASH_FLOW_BY_YEARS =
  "@freeCashFlow/REPLACE_FREE_CASH_FLOW_BY_YEARS";

export const RESET_FREE_CASH_FLOW_REDUCER =
  "@freeCashFlow/RESET_FREE_CASH_FLOW_REDUCER";

export const SET_FREE_CASH_FLOW_INITIAL_PERIOD =
  "@freeCashFlow/SET_FREE_CASH_FLOW_INITIAL_PERIOD";

export const SET_FREE_CASH_FLOW_INITIAL_PERIOD_MONTH =
  "@freeCashFlow/SET_FREE_CASH_FLOW_INITIAL_PERIOD_MONTH";

// FREE CASH FLOW END //

// BROWSER RESIZE //
export const SET_BROWSER_RESIZE = "@freeCashFlow/SET_BROWSER_RESIZE";

// LOADER
export const SET_CENTRAL_LOADER = "@centralLoader/SET_CENTRAL_LOADER";

// Unit Sales dynamic instance actions
export const ADD_UNIT_SALES_INSTANCE = "@unitSales/ADD_UNIT_SALES_INSTANCE";
export const UPDATE_UNIT_SALES_INSTANCE =
  "@unitSales/UPDATE_UNIT_SALES_INSTANCE";
export const REMOVE_UNIT_SALES_INSTANCE =
  "@unitSales/REMOVE_UNIT_SALES_INSTANCE";
export const SET_UNIT_SALES_INSTANCE_BY_MONTH =
  "@unitSales/SET_UNIT_SALES_INSTANCE_BY_MONTH";
export const REPLACE_UNIT_SALES_INSTANCE_MONTHS =
  "@unitSales/REPLACE_UNIT_SALES_INSTANCE_MONTHS";
export const RESET_UNIT_SALES_REDUCER = "@unitSales/RESET_UNIT_SALES_REDUCER";

// Billable Hours dynamic instance actions
export const ADD_BILLABLE_HOURS_INSTANCE =
  "@billableHours/ADD_BILLABLE_HOURS_INSTANCE";
export const UPDATE_BILLABLE_HOURS_INSTANCE =
  "@billableHours/UPDATE_BILLABLE_HOURS_INSTANCE";
export const REMOVE_BILLABLE_HOURS_INSTANCE =
  "@billableHours/REMOVE_BILLABLE_HOURS_INSTANCE";
export const SET_BILLABLE_HOURS_INSTANCE_BY_MONTH =
  "@billableHours/SET_BILLABLE_HOURS_INSTANCE_BY_MONTH";
export const REPLACE_BILLABLE_HOURS_INSTANCE_MONTHS =
  "@billableHours/REPLACE_BILLABLE_HOURS_INSTANCE_MONTHS";
export const RESET_BILLABLE_HOURS_REDUCER =
  "@billableHours/RESET_BILLABLE_HOURS_REDUCER";

// Recurring Charges dynamic instance actions
export const ADD_RECURRING_CHARGES_INSTANCE =
  "@recurringCharges/ADD_RECURRING_CHARGES_INSTANCE";
export const UPDATE_RECURRING_CHARGES_INSTANCE =
  "@recurringCharges/UPDATE_RECURRING_CHARGES_INSTANCE";
export const REMOVE_RECURRING_CHARGES_INSTANCE =
  "@recurringCharges/REMOVE_RECURRING_CHARGES_INSTANCE";
export const SET_RECURRING_CHARGES_INSTANCE_BY_MONTH =
  "@recurringCharges/SET_RECURRING_CHARGES_INSTANCE_BY_MONTH";
export const REPLACE_RECURRING_CHARGES_INSTANCE_MONTHS =
  "@recurringCharges/REPLACE_RECURRING_CHARGES_INSTANCE_MONTHS";
export const RESET_RECURRING_CHARGES_REDUCER =
  "@recurringCharges/RESET_RECURRING_CHARGES_REDUCER";

// General Other Revenue dynamic instance actions
export const ADD_GENERAL_OTHER_REVENUE_INSTANCE =
  "@generalOtherRevenue/ADD_GENERAL_OTHER_REVENUE_INSTANCE";
export const UPDATE_GENERAL_OTHER_REVENUE_INSTANCE =
  "@generalOtherRevenue/UPDATE_GENERAL_OTHER_REVENUE_INSTANCE";
export const REMOVE_GENERAL_OTHER_REVENUE_INSTANCE =
  "@generalOtherRevenue/REMOVE_GENERAL_OTHER_REVENUE_INSTANCE";
export const SET_GENERAL_OTHER_REVENUE_INSTANCE_BY_MONTH =
  "@generalOtherRevenue/SET_GENERAL_OTHER_REVENUE_INSTANCE_BY_MONTH";
export const REPLACE_GENERAL_OTHER_REVENUE_INSTANCE_MONTHS =
  "@generalOtherRevenue/REPLACE_GENERAL_OTHER_REVENUE_INSTANCE_MONTHS";
export const RESET_GENERAL_OTHER_REVENUE_REDUCER =
  "@generalOtherRevenue/RESET_GENERAL_OTHER_REVENUE_REDUCER";
